export default __webpack_public_path__ + "static/media/tag.a0cdc924.PNG";